import { Currency } from "../schema/Currency.js";
import { Locale } from "../schema/Locale.js";

const nativeLocaleMap: Record<Currency, string> = {
	[Currency.CZK]: Locale.cs,
	[Currency.EUR]: Locale.en,
	[Currency.PLN]: "pl",
};

const formatCache: Partial<Record<`${Currency}-${string}-${boolean}`, Intl.NumberFormat>> = {};
function createFormat(currency: Currency, locale = nativeLocaleMap[currency], withFraction = false): Intl.NumberFormat {
	const cached = formatCache[`${currency}-${locale}-${withFraction}`];
	if (cached) {
		return cached;
	}

	const format = new Intl.NumberFormat(locale, {
		style: "currency",
		currency,
		minimumFractionDigits: withFraction ? 2 : 0,
		maximumFractionDigits: 2,
	});
	formatCache[`${currency}-${locale}-${withFraction}`] = format;
	return format;
}

export function formatPrice(number: number, currency: Currency, locale: Locale, withFraction: boolean): string {
	return createFormat(currency, locale, withFraction).format(Object.is(number, -0) ? 0 : number);
}

export function getCurrencySymbol(currency: Currency, locale?: Locale): string {
	return (
		createFormat(currency, locale, false)
			.formatToParts(0)
			.find((part) => part.type === "currency")?.value ?? currency
	);
}
